/**
 * orga-app-api - incidents-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IncidentBerechtigung { 
    incident_id: string;
    benutzer_ist_manager?: boolean;
    benutzer_ist_ersteller?: boolean;
    benutzer_ist_bearbeiter?: boolean;
    benutzer_ist_leser?: boolean;
    mandant_id?: string;
    modified_on_utc?: Date;
}

